<template>
  <TeamsOverview action-id="100kmrun" :per-page="25">
    <template v-slot="{ row }">
      <div class="col-12 mb-4">
        <div class="kotk-team kotk-team--hkmrun-team view-mode--teaser" :data-id="row.drupal_internal__id">
          <div class="teaser">
            <a :href="[path, row.id].join('/')" class="teaser__url">
              <div class="teaser__content">
                <div class="teaser__title">{{ row.label }}</div>
                <div class="teaser__runners">{{row.field_num_teams}}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </template>
  </TeamsOverview>
</template>

<script>
import TeamsOverview from "@/components/Views/TeamsOverview.vue";

export default {
  name: "HkmrunTeamsOverview",
  components: {
    TeamsOverview,
  },
  data() {
    return {
      path: this.$window.location.pathname,
    }
  }
}
</script>
